import styled from 'styled-components'

export const Content = styled.div`
  display:flex;
  flex-direction: column;
  align-items: center;

  margin: 0 auto;
  margin-bottom: 15px;
  max-width: 640px;
  padding: 0 5px;

  @media screen and (max-width: 766px) {
    max-width: 550px;
  }
  @media screen and (max-width: 480px) {
    max-width: 420px;
  }
`
